import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'src/redux/store';
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import dayjs from 'dayjs';
import Router from './Router';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { MsgOrModalProvider } from './context';
import InitCommonProvider from './pages/components/InitCommonProvider';

import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <Router />
//     </Provider>
//   </React.StrictMode>,
// );
root.render(
  <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
    <InitCommonProvider>
      <Provider store={store}>
        <MsgOrModalProvider>
          <Router />
        </MsgOrModalProvider>
      </Provider>
    </InitCommonProvider>
  </StyleProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
